import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IconAdapter {
  private http = inject(HttpClient);

  getIcon(): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(`${environment.apiBaseUrl}/company/icon`);
  }

  editIcon(payload): Observable<{ url: string }> {
    return this.http.patch<{ url: string }>(`${environment.apiBaseUrl}/company/icon`, payload);
  }

  deleteIcon(): Observable<any> {
    return this.http.delete(`${environment.apiBaseUrl}/company/icon`);
  }
}
